/**
 * The §9.6b guard, mirrored from the server (`ai_predict_metadata.
 * ai_write_violations`): AI-predicted values may reach a node that writes to a
 * controlled system only through an Approval node. The canvas warns on Save;
 * the server refuses the run.
 */

import type { PipelineGraph } from "./graph";

const AI_KINDS = new Set(["ai.predict_metadata"]);
const WRITE_KINDS = new Set(["veeva.sink"]);
const APPROVAL_KIND = "flow.approval";

export function aiWriteViolations(graph: PipelineGraph): string[] {
  const nodes = new Map(graph.nodes.map((n) => [n.id, n]));
  const adj = new Map<string, string[]>();
  for (const e of graph.edges) adj.set(e.from, [...(adj.get(e.from) ?? []), e.to]);
  const out: string[] = [];
  for (const node of graph.nodes) {
    if (!AI_KINDS.has(node.type) || node.disabled) continue;
    const seen = new Set<string>();
    const stack = [...(adj.get(node.id) ?? [])];
    while (stack.length) {
      const cur = stack.pop() as string;
      const n = nodes.get(cur);
      // An auto-approving gate counts too (ADR-0040).
      const gate = n?.type === APPROVAL_KIND && !n.disabled;
      if (!n || seen.has(cur) || gate) continue;
      seen.add(cur);
      if (WRITE_KINDS.has(n.type) && !n.disabled) {
        out.push(
          "Metadata enrichment (AI) feeds Load to Veeva directly. AI-predicted values must be " +
            "reviewed by a person before they are written to Vault: add an Approval node " +
            "between them (Metadata enrichment → Approval → Load to Veeva).",
        );
      }
      stack.push(...(adj.get(cur) ?? []));
    }
  }
  return out;
}
